import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: space-between;
  padding-inline: 12px;

  @media (min-width: 768px) {
    flex-direction: row;

    button {
      width: auto;
    }
  }
`;

export const WrapperTuorList = styled.div`
  display: flex;
  margin-top: 40px;
  gap: 20px;

  @media (max-width: 1400px) {
    flex-direction: column;
  }
`;

export const WrapperInformPassengers = styled.div`
  display: flex;
  margin-top: 40px;
  gap: 20px;

  @media (max-width: 1400px) {
    flex-direction: column;
  }
`;

export const Container = styled.div`
  width: 100%;
  padding: 20px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 18px;

  h2 {
    margin: 0;
    font-size: 1.4rem;
  }

  span {
    color: #666;
    font-size: 0.9rem;
  }
`;

export const Message = styled.div`
  width: 100%;
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 14px;
`;

export const Button = styled.button`
  height: 36px;
  padding: 0 16px;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
`;

export const ChartHeader = styled.div`
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 8px;

  h3 {
    margin: 0;
    font-size: 1.25rem;
  }

  span {
    display: block;
    margin-top: 2px;
    color: #666;
    font-size: 0.85rem;
  }

  button {
    width: auto;
    min-height: 34px;
    padding: 0 14px;
    border: 0;
    border-radius: 4px;
    cursor: pointer;
  }
`;

export const ChartCard = styled.div`
  width: 100%;
  min-width: 0;
  padding: 8px;
  border-radius: 8px;
  background: #fff;
  box-sizing: border-box;
`;

export const Totals = styled.div`
  width: 210px;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 14px;

  @media (max-width: 850px) {
    width: 100%;
    height: auto;
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export const TotalItem = styled.div`
  width: 100%;
  min-height: 105px;
  padding: 14px;
  border-radius: 8px;
  background: #f5f7fa;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;

  span {
    color: #666;
    font-size: 0.85rem;
  }

  strong {
    font-size: 1.6rem;
    font-weight: 700;
  }

  @media (max-width: 850px) {
    width: auto;
    min-width: 150px;
    flex: 1;
  }
`;

type ConteudoRelatorioProps = {
  $comTotais: boolean;
};

export const RelatorioContainer = styled.div`
  width: 100%;
  height: calc(100vh - 48px);
  max-height: 760px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  padding: 16px;
  box-sizing: border-box;
`;

export const ConteudoRelatorio = styled.div<ConteudoRelatorioProps>`
  width: 100%;
  flex: 1;
  min-height: 0;

  display: grid;
  grid-template-columns: ${({ $comTotais }) =>
    $comTotais ? "minmax(0, 1fr) 210px" : "minmax(0, 1fr)"};

  gap: 18px;
  align-items: stretch;

  @media (max-width: 850px) {
    grid-template-columns: 1fr;
    overflow-y: auto;
  }
`;
